<template src="./index.html"></template>
<script>
import { getdata } from './data';
export default {
	data() {
		return {
			//表格
			headData: getdata().headData,
			tableData: [],
			pagination: getdata().pagination,
			tablekey: 0,
			//排序字段
			order: '',
			//排序顺序
			sort: '',
			//筛选字段
			param: {
				status: ['-1', '0', '1']
			},
			size:""
		};
	},
	created() {
		this.initialization();
	},
	methods: {
		//初始化
		initialization() {
			let params = {};
			params.limit = this.pagination.pageSize;
			params.page = this.pagination.pageNum;
			params.sort = this.sort;
			params.order = this.order;
			params.param = this.param;
			this.$https.fetchPost('schedule/record', params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//筛选
		forSearchScreeningBox(obj) {
			this.param = obj;
			this.initialization();
		},
		//表格体 排序
		sortchange(e) {
			if (e.order != null) {
				this.sort = e.order == 'ascending' ? 'ASC' : 'DESC';
				this.order = e.prop;
			} else {
				this.sort = '';
				this.order = '';
			}
			this.initialization();
		},
		//分页
		currentChange(e) {
			this.pagination.pageNum = e;
			this.initialization();
		},
		//行数
		sizechange(e) {
			this.pagination.pageSize = e;
			this.initialization();
		}
	}
};
</script>
<style scoped>
@import url('./index.less');
</style>
